import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import {
  checkoutOrderReducer,
  CheckoutOrderState,
} from './checkout-order.reducer';
import {
  currentOrderReducer,
  CurrentOrderState,
} from './current-order.reducer';
import {
  deliveryDetailsReducer,
  DeliveryDetailsState,
} from './delivery-details.reducer';

export interface OrderCheckoutState {
  checkoutOrder: CheckoutOrderState;
  currentOrder: CurrentOrderState;
  deliveryDetails: DeliveryDetailsState;
}

export const reducers: ActionReducerMap<OrderCheckoutState> = {
  checkoutOrder: checkoutOrderReducer,
  currentOrder: currentOrderReducer,
  deliveryDetails: deliveryDetailsReducer,
};

export const getOrderCheckoutState =
  createFeatureSelector<OrderCheckoutState>('orderCheckout');
